import { axiosBaseQuery } from '../axios-base-query';

export const realWorldBaseQuery = axiosBaseQuery({
  baseUrl: 'https://api.realworld.io/api',
});
